import { render, staticRenderFns } from "./SettingsSources.vue?vue&type=template&id=03dcfa1e"
import script from "./SettingsSources.vue?vue&type=script&lang=js"
export * from "./SettingsSources.vue?vue&type=script&lang=js"
import style0 from "./SettingsSources.vue?vue&type=style&index=0&id=03dcfa1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports